import { render, staticRenderFns } from "./Letter.vue?vue&type=template&id=002145c2&scoped=true"
import script from "./Letter.vue?vue&type=script&lang=js"
export * from "./Letter.vue?vue&type=script&lang=js"
import style0 from "./Letter.vue?vue&type=style&index=0&id=002145c2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002145c2",
  null
  
)

export default component.exports